

import React, { Component } from 'react';
import axios from 'axios'
import { Button, Card, Table, Row, Col } from 'react-bootstrap'
import Address from './address';
import { connect } from 'react-redux';
import { refreshJobInDraft } from '../actions/jobDraft';

class Shipping extends Component {
    state = {
        shippingCosts: [
        ],
        selected: null,
        address: {},
        addressValid: false
    }
    componentDidMount() {


    }
    selectOption = (option, data) => {
        axios.post("/api/prices/shipping/set-for-job", { job: this.props.jobDraft._id, shipping: option }).then(res => {
            this.setState({ selected: data })
            this.props.refreshJobInDraft(this.props.jobDraft._id)
            this.props.valid(this.state.addressValid)
        })
    }

    contactUpdated = async (values) => {
        await this.selectOption(null, null)
        let json = {
            FirstName: values.firstName,
            LastName: values.lastName,
            ContactType: values.contactType,
            OrganizationName: values.organisation,
            AddressLine1: values.addressLine1,
            AddressLine2: values.addressLine2,
            City: values.city,
            State: values.stateProvince,
            CountryCode: values.country,
            ZipCode: values.zipPostal,
            PhoneNumber: "+" + values.phoneCode + "." + values.phoneNumber,
            Email: values.email,
            //Fax
            //ExtraParams
        }
        this.setState({ address: json, addressValid: values.valid }, () => {
            if (this.state.addressValid) {
                axios.post("/api/prices/shipping/get-for-job", { job: this.props.jobDraft._id, address: this.state.address }).then(res => {
                    //todo also need to pass country and address.
                    this.setState({ shippingCosts: res.data.shipping, selected: null })
                    this.props.refreshJobInDraft(this.props.jobDraft._id)
                    // this.props.selectShipping(null, this.state.addressValid)
                    this.props.valid(this.state.addressValid)
                })
            }
        })



    }
    render() {
        let darkmode = this.props.user ? this.props.user.darkmode : true

        let shipping = []
        this.state.shippingCosts != "quote needed" && this.state.shippingCosts.forEach(option => {
            shipping.push(
                <tr key={option._id}>
                    <td >{option.name} </td>
                    <td >£{option.cost}</td>

                    <td>
                        <Button type='submit' onClick={() => this.selectOption(option._id, option)}>
                            Select
                        </Button>
                    </td>
                </tr>
            )
        })

        return (
            <div style={{ overflow: "auto", height: "100%" }}>
                <div>
                    <div style={{ margin: '30px' }}>

                        <h2 style={{ textAlign: 'center' }}>
                            Address
                        </h2>
                        <div  >
                            <Address contactUpdated={this.contactUpdated} />

                        </div>

                    </div>
                    {this.state.addressValid && this.state.shippingCosts &&
                        <div style={{ margin: '30px' }}>

                            <h2 style={{ textAlign: 'center' }}>
                                Shipping
                            </h2>
                            <div style={{ 'margin': '0px' }} >
                                {this.state.shippingCosts == "quote needed" ? <div>Custom quote needed. A member of our shipping team will be in contact</div> :
                                    <div>
                                        {
                                            this.state.selected == null ?
                                                <Table style={{ 'margin': '0px' }} bordered>
                                                    <thead>
                                                        <tr className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}>
                                                            <th>Name</th>
                                                            <th>Cost</th>
                                                            <th>Select</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                                                        {shipping}
                                                    </tbody>
                                                </Table>
                                                :
                                                <div>

                                                    <Row>
                                                        <Col >{this.state.selected.name} </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col >£{this.state.selected.cost}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Button type='submit' onClick={() => this.selectOption(null, null)}>
                                                                Change Shipping
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                        }
                                    </div>

                                }

                            </div>

                        </div>
                    }
                    {this.state.addressValid && !this.state.shippingCosts &&
                        <div>
                            Loading shipping options
                        </div>
                    }
                </div>



            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        jobDraft: state.jobDraft
    }
}
function mapDispatchToProps(dispatch) {
    return {
        refreshJobInDraft: (jobId) => dispatch(refreshJobInDraft(jobId))

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Shipping);